// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__zBlm2","pagination_button":"Pagination_pagination_button__nr3bu","pagination_text":"Pagination_pagination_text__lZc80"};